import React from 'react';
import Cart from '../Components/Cart';
import { translate } from '../Services/translation';

const MiniCart = cart => {
    const { toggle, updateOrderRowQuantity, removeOrderRow } = cart;
    const isCasallPro = document.body.classList.contains('casall-pro');
    return !cart.checkoutUrl ? (
        <></>
    ) : (
        <div className="cart cart--mini">
            <a className="cart__link--block" onClick={() => toggle()}>
                <span className="cart__icon">
                    <img
                        className="icon"
                        src="/ui/images/shopping-bag.svg"
                        alt="Cart icon"
                    />
                    <span className="cart__quantity">{cart.quantity}</span>
                </span>
            </a>
            <div
                id="mini-cart-contents"
                className={`cart__info ${
                    !cart.showInfo ? 'cart__info--hidden' : ''
                }`}
            >
                <div className="mini-cart-top">
                    <div className="row">
                        <div className="columns mini-cart-top-wrapper">
                            <span className="minicart-title">
                                {translate('checkout.cart')}
                            </span>
                            <span
                                id="cart-close-button"
                                className="cart__close-button"
                                onClick={() => toggle()}
                            >
                                <img
                                    src="/ui/images/close_black.svg"
                                    alt="Close icon"
                                />
                            </span>
                        </div>
                    </div>
                </div>
                <div className="mini-cart-content-wrapper">
                    {cart.quantity > 0 ? (
                        <>
                            <Cart
                                {...{
                                    ...cart,
                                    updateOrderRowQuantity:
                                        updateOrderRowQuantity,
                                    removeOrderRow: removeOrderRow,
                                }}
                            />
                        </>
                    ) : (
                        <div className="row empty-cart-notice">
                            <div className="columns">
                                {translate('checkout.cart.empty')}
                            </div>
                        </div>
                    )}
                </div>

                <div className="minicart-button-holder">
                    {cart.freeShippingLimit && (
                        <div className="minicart-free-shipping">
                            <p>
                                {cart.amountLeftToFreeShipping}{' '}
                                {translate('checkout.freeshipping.amountleft')}
                            </p>
                        </div>
                    )}
                    <div className="minicart-order-info-wrapper">
                    {isCasallPro && (cart.hasQuotationProductInCart || !cart.isAuthenticated) ? <></>
                        : (  
                            <div className="cart-order-total">
                                <h3 className="text--right">
                                    <span className="float-left">
                                        {translate('checkout.cart.total')}
                                    </span>{' '}
                                    {cart.orderTotal}
                                </h3>
                            </div>
                        )}
                        <a
                            href={cart.checkoutUrl}
                            className="cart__checkout-button"
                        >
                            {translate('minicart.checkout')}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default MiniCart;
